import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { SocialButton } from '../SocialButton';
import cn from 'classnames';
import * as styles from './Social.css';
export function Social(_ref) {
  var isExpanded = _ref.isExpanded,
      onClick = _ref.onClick,
      list = _ref.list,
      listShort = _ref.listShort,
      expand = _ref.expand,
      error = _ref.error,
      frameless = _ref.frameless;
  var socialButtons = React.useMemo(function () {
    if (!isExpanded) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, listShort.map(function (socialType) {
        return /*#__PURE__*/React.createElement(SocialButton, {
          dataMark: "SocialBtn".concat(socialType[0].toUpperCase()).concat(socialType.slice(1).toLowerCase()),
          key: "social_button-".concat(socialType),
          type: socialType,
          onClick: onClick
        });
      }), /*#__PURE__*/React.createElement(SocialButton, {
        dataMark: "SocialExpandBtn",
        onClick: expand
      }));
    }

    return list.map(function (socialType) {
      return /*#__PURE__*/React.createElement(SocialButton, {
        onClick: onClick,
        type: socialType,
        key: "social_button-".concat(socialType),
        dataMark: "SocialBtn".concat(socialType[0].toUpperCase()).concat(socialType.slice(1).toLowerCase())
      });
    });
  }, [expand, isExpanded, list, listShort, onClick]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles['container'], _defineProperty({}, styles['frameless'], frameless))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['buttons']
  }, socialButtons), error && /*#__PURE__*/React.createElement("div", {
    className: styles['error']
  }, error));
}